import React from 'react';
import './Layout2.css';
import { ForwardIcon, HeartIcon, MessageCircleMore } from 'lucide-react';

const Layout2 = ({ data }) => {
  const { video, brand } = data;

  const getVideoFrameStyle = () => {
    const style = {
      width: `${video.width || 100}%`,
      height: `${video.height || 100}%`,
      boxShadow: video.shadow || '0 4px 15px rgba(0, 0, 0, 0.5)',
    };

    // Apply shape
    if (video.shape === 'none') {
      style.borderRadius = '0';
    } else if (video.shape === 'rounded') {
      style.borderRadius = '16px';
    } else if (video.shape === 'circle') {
      style.borderRadius = '50%';
      style.aspectRatio = '1/1';
    } else if (video.shape === 'square') {
      style.borderRadius = '0';
    } else if (video.shape === 'rounded-lg') {
      style.borderRadius = '24px';
    } else {
      style.borderRadius = '16px'; // default
    }

    return style;
  };

  return (
    // style={{ background: getLayoutBackground() }}
    <div className="layout2-container">
      <div className="layout2-content">
        {/* Top Text */}
        <div className="layout2-top-text">
          <h2 className="main-question">{video.subtitle1}</h2>
          <p className="sub-question">{video.subtitle2}</p>
        </div>

        {/* Main Content Area */}
        <div className="layout2-main-area">
          {/* Left - Brand Logo */}
          <div className="layout2-logo-section">
            {brand.logoUrl ? (
              <img src={brand.logoUrl} alt="Brand Logo" className="brand-logo-img" />
            ) : (
              <div className="brand-logo-text">H&M</div>
            )}
          </div>

          {/* Center - Video Frame */}
          <div className="layout2-video-section">
            <div className="video-frame-centered" style={getVideoFrameStyle()}>
              <div className="video-content-centered">
                {video.url ? (
                  <>
                    <video src={video.url} className="video-player-centered" autoPlay muted loop playsInline />

                    <div className="absolute bottom-0 left-0 w-full py-3 px-1 flex items-center justify-center gap-10 text-white text-sm font-semibold">
                      <div className="flex items-center gap-2">
                        <span><MessageCircleMore className="h-6 w-6" /></span>
                        <span>{video.comments}</span>
                      </div>

                      <div className="flex items-center gap-2">
                        <span><ForwardIcon className="h-6 w-6" /></span>
                        <span>{video.shares}</span>
                      </div>

                      <div className="flex items-center gap-2">
                        <span><HeartIcon fill="red" stroke="red" className="h-6 w-6" /></span>
                        <span>{video.likes}</span>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="video-placeholder-centered">
                    <div className="placeholder-icon">▶</div>
                    <p>Upload Video</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Right - QR Code */}
          <div className="layout2-qr-section">
            <div className="qr-content">
              <div className="website-text">{brand.website}</div>
              {brand.qrCodeUrl ? (
                <img src={brand.qrCodeUrl} alt="QR Code" className="qr-code-centered" />
              ) : (
                <div className="qr-placeholder-centered">QR Code</div>
              )}
              <div className="shop-text">{brand.shopText}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout2;
